import { configureStore } from '@reduxjs/toolkit';
import { faqApi } from './api/faqApi';

export const store = configureStore({
  reducer: {
    [faqApi.reducerPath]: faqApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(faqApi.middleware),
});
